import React, { Component } from 'react';
import { connect } from 'react-redux';
import { startCase } from 'lodash';
import { Link } from 'react-router-dom';
import StripeCheckout from 'react-stripe-checkout';
import * as actions from '../../actions';
import './style.css';

class SubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.renderStripeCheckoutLink = this.renderStripeCheckoutLink.bind(this);
    this.handleToken              = this.handleToken.bind(this);
  }

  renderOldMonthlyPayments() {
    if (
      this.props.auth.email === 'lucidwebgroup@gmail.com' ||
      this.props.auth.email === 'anthony.deguzm@gmail.com'
    ) {
      return (
        <div>
          <div className="modal-content row">
            <div className="col s12">
              <div className="card blue-grey darken-1" style={{paddingRight: '5px'}}>
                <div className="card-content white-text">
                  <span className="card-title">Old Monthly Plan</span>
                  <p>$9.99 CAD / month</p>
                </div>
                <div className="card-action stripe-checkout-month">
                  {this.renderStripeCheckoutLink(9.99, 'old_month')}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  handleToken(tokenObj, interval) {
    this.props.handleStripeToken(tokenObj, interval);
  }

  renderStripeCheckoutLink(price, interval) {
    return <StripeCheckout
      name='Page Outil Subscription'
      description={`Unlock all data for $${price} CAD / ${interval === 'old_month' ? 'month' : interval}`}
      amount={price * 100}
      email={this.props.auth.email}
      token={tokenObj=> this.handleToken(tokenObj, interval)}
      stripeKey={process.env.REACT_APP_STRIPE_KEY}
      currency='CAD'
      locale='en'
      panelLabel={`${startCase(interval === 'old_month' ? 'month' : interval)}ly`}>
      <Link to={`#subscribe/stripe?plan=${interval}`} onClick={e => {
        e.preventDefault();
        const { $ } = window;
        $('#subscribe-modal').modal('close');
      }}>Subscribe now</Link>
    </StripeCheckout>
  }

  render() {
    return (
      <div id="subscribe-modal" className="modal">
        <div className="modal-content row">
          <h4>Subscribe to Page Outil</h4>
          <p>Get access to all pages and queries to your websites. Comes with the feature to export your data.</p>
          <div className="col s6">
            <div className="card blue-grey darken-1" style={{paddingRight: '5px'}}>
              <div className="card-content white-text">
                <span className="card-title">Monthly</span>
                <p>$20.00 CAD / month</p>
              </div>
              <div className="card-action stripe-checkout-month">
                {this.renderStripeCheckoutLink(20.00, 'month')}
              </div>
            </div>
          </div>
          <div className="col s6">
            <div className="card blue-grey darken-1">
              <div className="card-content white-text">
                <span className="card-title">Yearly</span>
                <p>$18.00 CAD / month - 10% Discount</p>
              </div>
              <div className="card-action stripe-checkout-year">
                {this.renderStripeCheckoutLink(18.00 * 12, 'year')}
              </div>
            </div>
          </div>
        </div>
        {this.renderOldMonthlyPayments()}
        <div className="modal-content row">
          <div className="modal-footer">
              <img alt="stripe" src={`${process.env.PUBLIC_URL}assets/powered_by_stripe@2x.png`} width="149" height="41" />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps({ auth }) {
  return { auth };
};

export default connect(mapStateToProps, actions)(SubscriptionModal);



// WEBPACK FOOTER //
// ./src/components/Dashboard/SubscriptionModal.js